import { RECEIVE_CART_APPS } from '../actions/cart';

const defaultState = {
  ifpApps: [],
};

export default function cart(state = defaultState, action) {
  Object.freeze(state);

  switch (action.type) {
    case RECEIVE_CART_APPS:
      return {
        ifpApps: action.apps,
      };
    default:
      return state;
  }
}
